import React, { Component } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink} from 'reactstrap';
import '../style/style.css';
import 'bootstrap/dist/css/bootstrap.css';


class Header extends Component {
    constructor(props) {
      super(props);
      this.toggle = this.toggle.bind(this);
      this.state = {
        isOpen: false
      };
    }

    toggle() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }

    renderNavBarItems(){
        if (this.props.navbaritems) {
            return (this.props.navbaritems.map((Item) =>
                <NavItem key = {Item.Name}>
                    <NavLink className={"header-nav-item" + (Item.Active ? " active" : "")} href={Item.Link}>{Item.Name}</NavLink>
                </NavItem>
            ))
        }
    }

    textForHeader () {
        if (this.props.name && this.props.name !== '') {
            return `${this.props.name}`;
        }
    }

    render() {
      return (
          <div className="Header">
              <Navbar light expand="lg">

                    <div className="mynavbrand">
                    <a href="/">
                        mntd<span className="blue-dot">.</span>
                            </a>
                    </div>


                <NavbarToggler onClick={this.toggle}/>
                <Collapse isOpen={this.state.isOpen} navbar>
                  <Nav navbar className="ml-auto">
                    {this.renderNavBarItems()}
                    <NavItem>
                        <NavLink className="header-username">{this.textForHeader()}</NavLink>
                    </NavItem>
                  </Nav>
                </Collapse>

              </Navbar>
          </div>
      );
    }
  }

  export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js